import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";

import PanelsLayout from "components/PanelsLayout";
import EmptyPanel from "components/EmptyPanel";
import { ERadixListView, ERadixProgram } from "dto/Radix/IRadix";

import RadixList from "./RadixList";
import styles from "./radix.module.scss";

// Moduł RADIX — port Kwantum.Radix.UI.Workspace (Menu + listy) z Magistratu:
//   /radix/decisions      — Decyzje (PoGrun)        — pisma po imporcie (Redakcja/Zaimportowane),
//   /radix/reminders      — Upomnienia (WIP),
//   /radix/notifications  — Zawiadomienia (GOK),
//   /radix/to-send        — Do wysłania (wszystkie programy, ReadyToDispatch),
//   /radix/sent           — Wysłane (bieżący rok).
// Wnioski EBOI pominięte (Nota nie ma integracji EBOI).

type RadixViewKey = "decisions" | "reminders" | "notifications" | "to-send" | "sent";

const RADIX_VIEWS: Record<
  RadixViewKey,
  { view: ERadixListView; title: string; program: ERadixProgram | null }
> = {
  decisions: { view: ERadixListView.Decisions, title: "Decyzje", program: ERadixProgram.PoGrun },
  reminders: { view: ERadixListView.Reminders, title: "Upomnienia", program: ERadixProgram.WIP },
  notifications: { view: ERadixListView.Notifications, title: "Zawiadomienia", program: ERadixProgram.GOK },
  "to-send": { view: ERadixListView.ToSend, title: "Do wysłania", program: null },
  sent: { view: ERadixListView.Sent, title: "Wysłane", program: null },
};

const RadixModule = () => {
  const { view } = useParams();
  const key: RadixViewKey = (view && view in RADIX_VIEWS ? view : "decisions") as RadixViewKey;
  const def = useMemo(() => RADIX_VIEWS[key], [key]);

  const [searchText, setSearchText] = useState("");
  const [debouncedText] = useDebounce(searchText, 300);

  return (
    <PanelsLayout
      title="RADIX"
      subTitle={def.title}
      onChangeSearch={(text: string) => setSearchText(text)}
      leftPanel={
        <div className={styles.panel}>
          <RadixList key={key} view={def.view} program={def.program} searchText={debouncedText} />
        </div>
      }
      hideRight={true}
      rightPanel={<EmptyPanel />}
      isSearchExpanded={true}
    />
  );
};

export default RadixModule;
